/**
 * Generate responsive image URLs with Supabase image transformation API
 * Sizes: mobile (640px), tablet (1024px), desktop (1920px)
 */

export const generateSupabaseSrcset = (imageUrl) => {
  if (!imageUrl) return '';
  
  // Extract the base URL before any transformation parameters
  const baseUrl = imageUrl.split('?')[0];
  
  // Define breakpoints and their corresponding widths
  const sizes = {
    mobile: 640,    // sm breakpoint
    tablet: 1024,   // lg breakpoint
    desktop: 1920   // desktop
  };

  // Generate srcset with Supabase transform parameters
  // Supabase transform API format: image.png?width=640&quality=80
  const srcset = [
    `${baseUrl}?width=${sizes.mobile}&quality=80 ${sizes.mobile}w`,
    `${baseUrl}?width=${sizes.tablet}&quality=85 ${sizes.tablet}w`,
    `${baseUrl}?width=${sizes.desktop}&quality=90 ${sizes.desktop}w`
  ].join(', ');

  return srcset;
};

/**
 * Get the default image URL (used as fallback)
 * Can optionally apply optimization to default as well
 */
export const getOptimizedImageUrl = (imageUrl, width = 1024) => {
  if (!imageUrl) return '';
  const baseUrl = imageUrl.split('?')[0];
  return `${baseUrl}?width=${width}&quality=85`;
};

/**
 * Generate sizes attribute for responsive images
 * Helps browser decide which image to download based on viewport
 */
export const getImageSizes = () => {
  return '(max-width: 640px) 100vw, (max-width: 1024px) 100vw, 100vw';
};
